import { Box } from '@jfs/ui-new'
import { FlatList } from 'react-native'
import { AccordionItem } from './AccordionItem'
import { FIXTURE_DATA } from './Fixture'
import { style } from './style'

const Accordion = ({ hide, data, isMobile }: any) => {
  const renderItem = ({ item, index }: any) => {
    const totalDataLength = data?.length ?? FIXTURE_DATA?.length
    return <AccordionItem data={item} index={index} totalDataLength={totalDataLength} isMobile={isMobile} />
  }

  if (hide) {
    return null
  }

  return (
    <Box {...style.mainCont}>
      <FlatList
        data={data ?? FIXTURE_DATA}
        keyboardDismissMode="on-drag"
        keyboardShouldPersistTaps={'always'}
        showsVerticalScrollIndicator={false}
        renderItem={renderItem}
        keyExtractor={(item) => String(item?.title)}
        contentContainerStyle={style.contentContainerStyle}
      />
    </Box>
  )
}

export { Accordion }
